import { IUser } from './user';

export type AccessRole = 'SAdmin' | 'Admin' | 'User' | 'Agent' | string;

export function accessRole(user: IUser | null | undefined): AccessRole | null {
  const mapping = user?.DashRoleMapping?.[0];
  if (!mapping) return null;
  const name = mapping.DashRole?.name?.toLowerCase();
  if (user.customerId == null && Number(mapping.roleId) === 1 && name === 'sadmin') return 'SAdmin';
  if (name === 'sadmin') return null;
  if (mapping.principalType === 'AGENT') return 'Agent';
  if (['ADMIN', 'ADMINISTRATOR'].includes(mapping.principalType)) return 'Admin';
  if (mapping.principalType === 'USER') return 'User';
  if (mapping.principalType) return mapping.DashRole?.name || mapping.principalType;
  if (name === 'agent') return 'Agent';
  if (name === 'admin' || name === 'administrator' || name?.endsWith(' admin')) return 'Admin';
  if (name === 'user' || name?.endsWith(' user')) return 'User';
  return mapping.DashRole?.name || null;
}

export function isPlatformAdmin(user: IUser | null | undefined): boolean {
  return accessRole(user) === 'SAdmin';
}
